const COMPANY_LEVEL = 3;
export const showOfficeEmulation = (userLevels) => (
  userLevels?.userLevel === COMPANY_LEVEL || userLevels?.multiBranch
);